import { useIdioma } from "../../i18n/IdiomaProvider";
import styles from "./CardAjudaTela.module.css";

export interface CardAjudaTelaProps {
  /** Para que serve a tela. */
  paraQueServe: string;
  /** Como preencher — um item por campo/etapa. */
  comoPreencher?: string[];
  /** Como funciona depois de salvo. */
  comoFunciona?: string;
}

/**
 * Card de orientação de uso da tela: contorno pontilhado, texto discreto e três
 * blocos fixos (para que serve, como preencher, como funciona). Usado no topo
 * das abas de Configurações para que ninguém precise adivinhar o que preencher.
 */
export function CardAjudaTela({ paraQueServe, comoPreencher = [], comoFunciona }: CardAjudaTelaProps) {
  const { traduzir } = useIdioma();

  return (
    <section className={styles.card} aria-label={traduzir("Como usar esta tela")}>
      <p className={styles.linha}>
        <strong>{traduzir("Para que serve")}:</strong> {traduzir(paraQueServe)}
      </p>

      {comoPreencher.length > 0 && (
        <div className={styles.linha}>
          <strong>{traduzir("Como preencher")}:</strong>
          <ul className={styles.lista}>
            {comoPreencher.map((item) => (
              <li key={item}>{traduzir(item)}</li>
            ))}
          </ul>
        </div>
      )}

      {comoFunciona && (
        <p className={`${styles.linha} ${styles.detalhe}`}>
          <strong>{traduzir("Como funciona")}:</strong> {traduzir(comoFunciona)}
        </p>
      )}
    </section>
  );
}
